function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { RadioChecked, RadioEmpty } from 'pcln-icons';
import { applyVariations, deprecatedColorValue, getPaletteColor } from '../utils';
var RadioWrap = styled.div.withConfig({
  displayName: "Radio__RadioWrap",
  componentId: "sc-15v2f0n-0"
})(["display:inline-block;color:", ";&:hover > svg{", ";}", ""], getPaletteColor('border.base'), function (props) {
  if (props.checked && !props.disabled) {
    return "color: ".concat(getPaletteColor('dark')(props), " !important;");
  }

  return props.disabled ? null : "color: ".concat(getPaletteColor('base')(props), ";");
}, applyVariations('Radio'));
var RadioInput = styled.input.withConfig({
  displayName: "Radio__RadioInput",
  componentId: "sc-15v2f0n-1"
})(["appearance:none;opacity:0;position:absolute;z-index:0;& ~ svg{border:1px solid transparent;border-radius:50%;padding:2px;}&:focus{box-shadow:none;& ~ svg{border:1px solid ", ";background-color:", ";}}&:checked ~ svg{color:", ";}&:disabled ~ svg{color:", ";}"], getPaletteColor('border.base'), getPaletteColor('background.light'), getPaletteColor('base'), getPaletteColor('border.base'));
var RadioCheckedIcon = styled(RadioChecked).withConfig({
  displayName: "Radio__RadioCheckedIcon",
  componentId: "sc-15v2f0n-2"
})(["vertical-align:middle;"]);
var RadioEmptyIcon = styled(RadioEmpty).withConfig({
  displayName: "Radio__RadioEmptyIcon",
  componentId: "sc-15v2f0n-3"
})(["vertical-align:middle;"]);

var RadioIcon = function RadioIcon(_ref) {
  var checked = _ref.checked,
      props = _objectWithoutProperties(_ref, ["checked"]);

  return checked ? /*#__PURE__*/React.createElement(RadioCheckedIcon, props) : /*#__PURE__*/React.createElement(RadioEmptyIcon, props);
};

RadioIcon.propTypes = {
  checked: PropTypes.bool
};
var Radio = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var checked = props.checked,
      disabled = props.disabled,
      size = props.size;
  var borderAdjustedSize = size + 4;
  return /*#__PURE__*/React.createElement(RadioWrap, {
    color: props.color,
    checked: checked,
    disabled: disabled
  }, /*#__PURE__*/React.createElement(RadioInput, _extends({
    type: "radio"
  }, props, {
    ref: ref
  })), /*#__PURE__*/React.createElement(RadioIcon, {
    checked: checked,
    size: borderAdjustedSize
  }));
});
Radio.displayName = 'Radio';
Radio.propTypes = {
  color: deprecatedColorValue(),
  size: PropTypes.number,
  checked: PropTypes.bool,
  disabled: PropTypes.bool
};
Radio.defaultProps = {
  color: 'primary',
  size: 24
};
export default Radio;